import { FC, ReactNode } from 'react';
import { DeepReadonlyObject } from 'rxdb';

import { LegView } from '@mopla/data-models';
import {
	calculateItineraryPricingsRange,
	checkHasLegWithoutPaymentInfo,
} from '@mopla/utils';

import { defaultRenderer } from './defaultRenderer';
import { IPriceStringProps, PriceString } from './PriceString';

export interface IPriceBlockProps {
	legs: DeepReadonlyObject<LegView | LegView[]>;
	render?: (children: ReactNode) => ReactNode;
	i18nVersion?: IPriceStringProps['i18nVersion'];
}

export const PriceBlock: FC<IPriceBlockProps> = ({
	legs,
	render = defaultRenderer,
	i18nVersion,
}) => {
	const _legs = Array.isArray(legs) ? legs : [legs];
	const priceRange = calculateItineraryPricingsRange({ legs: _legs });
	const hasPriceTariff = checkHasLegWithoutPaymentInfo(_legs);

	return (
		<>
			{render(
				<PriceString
					priceRangePerPerson={priceRange}
					hasPriceTariff={hasPriceTariff}
					single={_legs.length === 1}
					i18nVersion={i18nVersion}
				/>
			)}
		</>
	);
};
